import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';

@Component({
  selector: 'app-spanish-grammar-checker',
  templateUrl: './spanish-grammar-checker.component.html',
  styleUrls: ['./spanish-grammar-checker.component.scss']
})
export class SpanishGrammarCheckerComponent implements OnInit {
  public minLength = 0;
  public maxLength = 300;
  editorConfig: any = {
    endpoint: environment.server_url.multilingual_server,
    lang: 'es',
    minHeight: 360,
    sessionLimit: 3
  };

  constructor(
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }
  showSnackBar($event: any) {
    console.log('showSnackBar ===> ', $event);
    this._snackBar.open($event, '', {
      duration: 3000
    });
  }
  sessionExhausted($event: any) {
    console.log('limitExhausted ===> ', $event);
    this._dialog.open(DetectionLimitExhaustModalComponent, {
      backdropClass: 'custom-dialog-background',
      width: '490px',
      height: 'auto',
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: "border-radius16",
    });
  }
  openFeedbackModal($event: any) {
    console.log('openFeedbackModal ===> ', $event);
    const dialogRef = this._dialog.open(FeedbackModalComponent, {
      width: '464px',
      height: 'auto',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        feature: 'multilingual',
        language: this.editorConfig.lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  ngAfterViewInit() {

    const ul = document.querySelector('lib-multilingual-editor-marketing .degreeChange ul');

    if (ul && ul.children.length === 1) {
      const li = ul.querySelector('li');

      if (li) {
        while (li.firstChild) {
          ul.parentNode?.insertBefore(li.firstChild, ul);
        }

        ul.remove();
      }
    }

    setTimeout(() => {
      const h3 = document.querySelector(
        'lib-multilingual-editor-marketing .card-header h3'
      );
  
      if (h3 && h3.textContent?.trim() === 'Original Text') {
        const h2 = document.createElement('h2');
  
        // Copy attributes
        Array.from(h3.attributes).forEach(attr =>
          h2.setAttribute(attr.name, attr.value)
        );
  
        h2.innerHTML = h3.innerHTML;
  
        h3.parentNode?.replaceChild(h2, h3);
      }
    });

    setTimeout(() => {
      const feedback = document.querySelector(
        'lib-multilingual-editor-marketing .feedback'
      ) as HTMLElement;
  
      if (!feedback) return;
  
      feedback.setAttribute('role', 'button');
      feedback.setAttribute('tabindex', '0');
  
      feedback.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          feedback.click();
        }
      });
    });
  }

  

}
